import { Box, Button, useMediaQuery } from "@material-ui/core";
import { FC } from "react";
import theme from "./theme";
import backIcon from "../assets/images/BackIcon.svg";
import { useHistory } from "react-router";
const BackButton: FC<any> = ({
  route,
  whitelistedCompleted,
  investBtn,
  goBack = false,
}) => {
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const history = useHistory();

  const BackIcon = () => {
    return <img src={backIcon} alt="gains" />;
  };
  return (
    <Box mb={isActive ? 2 : 4}>
      <Button
        variant="outlined"
        className="back-btn"
        color="secondary"
        startIcon={<BackIcon />}
        onClick={() => {
          goBack
            ? history.goBack()
            : history.push(`/${route}`, { whitelistedCompleted, investBtn });
        }}
      >
        Go Back
      </Button>
    </Box>
  );
};
export default BackButton;
